/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');
var Radio = require('backbone.radio');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetExternalComplaint = require('../../complaint-form/services/GetExternalComplaint');
var GetDocumentTypesByDepartment = require('common/services/GetDocumentTypesByDepartment');

var ConSerComplaintSectionExternalCorrespondenceView = require('../views/ConSerComplaintExternalCorrespondenceNewView');

module.exports = function(complaintId) {
  NProgress.start();
  NProgress.set(0.4);
  $.when(GetExternalComplaint(complaintId), GetDocumentTypesByDepartment('CONSUMER_SERVICES'))
    .done(function(complaint, documentTypes) {
      NProgress.set(0.7);
      NavUtils.navigate('ext/conser/complaint/' + complaintId + '/new-correspondence');
      Scaffold.content.show(
        new ConSerComplaintSectionExternalCorrespondenceView({
          model: new Backbone.Model({
            complaintId: complaintId,
            complaint: complaint,
            documentTypes: documentTypes
          })
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
      if (err.message.code === 'bpm:403') {
        Radio.channel('navigate').trigger('show:ext:cs:dashboard');
      }
    });
};
